

































import {Component, Inject, Vue, Watch} from 'vue-property-decorator';
import {BaseLink} from '@/core/standard/BaseLink';
import {ILink, Links} from '@/setup/router/links';
// @ts-expect-error
import VueFullLoading from 'vue-full-loading';
import {ILoadingConfig} from '@/setup/fullLoading/fullLoadingConfig';
import {IGlobals} from '@/modules/settings/global/IGlobalSettingsModel';
import {IGlobalConfigs} from '@/setup/GlobalConfigs/IGlobalConfigs';
import {IKitchenTickets} from '@/modules/settings/kitchen-ticket/IKitchenTicketSettingsModel';
import {DEFAULT_LAYOUT} from '@/constants';
import {IDomicilePickups} from '@/modules/settings/domicile_pickup/IDomicilePickupSettingsModel';
import {IBookings} from '@/modules/settings/booking/IBookingSettingModel';
import {IUnits} from '@/modules/units/IUnitModel';
import {loadLanguageAsync} from '@/setup/lang';
import {IStocks, IStockSettingsModel,} from '@/modules/settings/stock/IStockSettingModel';
import {ITickets} from '@/modules/settings/ticket/ITicketSettingsModel';


@Component({name: 'App', components: {VueFullLoading}})
export default class App extends Vue {
  @Inject({from: Symbol.for('Links')}) links!: ILink[];
  @Inject({from: Symbol.for('LoadingConfig')}) fullLoadingConfig!: ILoadingConfig;
  @Inject({from: Symbol.for('GlobalConfigs')}) GlobalConfigs!: IGlobalConfigs;
  @Inject({from: Symbol.for('GlobalSetting')}) Global!: { new(): IGlobals };
  @Inject({from: Symbol.for('KitchenTicketSetting')}) KitchenSettings!: { new(): IKitchenTickets };
  @Inject({from: Symbol.for('DomicilePickupSetting')}) DomicilePickupSettings!: { new(): IDomicilePickups };
  @Inject({from: Symbol.for('BookingSetting')}) BookingSettings!: { new(): IBookings };
  @Inject({from: Symbol.for('Unit')}) Unit!: { new(): IUnits };
  @Inject({from: Symbol.for('StockSetting')}) StockSettings!: { new(): IStocks };
  @Inject({from: Symbol.for('TicketSetting')}) TicketSetting!: { new(): ITickets };

  globalSettingsModel: IGlobals = {} as IGlobals;
  kitchenTicketSettingsModel: IKitchenTickets = {} as IKitchenTickets;
  domicilePickupSettingsModel: IDomicilePickups = {} as IDomicilePickups;
  bookingSettingsModel: IBookings = {} as IBookings;
  unitModel: IUnits = {} as IUnits;
  stockSettingsModel: IStockSettingsModel = {} as IStockSettingsModel;
  ticketSettingsModel: ITickets = {} as ITickets;

  layout: string = DEFAULT_LAYOUT;
  currentLayout: any = {};

  @Watch('$route')
  ifRouteChange(route) {
    route.meta.layout = !!route.meta.layout ? route.meta.layout : DEFAULT_LAYOUT;
    if (route.meta.layout && this.layout !== route.meta.layout) {
      this.layout = route.meta.layout;
    }
    this.getLayoutComponent(this.layout);
  }

  async created() {
    this.getLayoutComponent(this.$route.meta.layout || DEFAULT_LAYOUT);
    if (localStorage.getItem('token')) {
      this.globalSettingsModel = new this.Global();
      this.kitchenTicketSettingsModel = new this.KitchenSettings();
      this.domicilePickupSettingsModel = new this.DomicilePickupSettings();
      this.bookingSettingsModel = new this.BookingSettings();
      this.stockSettingsModel = new this.StockSettings();
      this.ticketSettingsModel = new this.TicketSetting();

      const [global, kitchen, domicilePickup, booking, stock, ticket] = await Promise.all([
        this.globalSettingsModel.get({}),
        this.kitchenTicketSettingsModel.get({}),
        this.domicilePickupSettingsModel.get({}),
        this.bookingSettingsModel.get({}),
        this.stockSettingsModel.get({}),
        this.ticketSettingsModel.get({}),
      ]);
      Object.keys(this.GlobalConfigs).forEach(key => {
        this.GlobalConfigs[key] = booking[key] ?? global[key] ?? kitchen[key] ??
         domicilePickup[key] ?? stock[key] ?? ticket[key];
      });
    }
    
    const localModules = localStorage.getItem('modules');
    if (localModules) {
      const modules = JSON.parse(localModules);
      BaseLink.clean(this.links);
      this.links.forEach((link) => {
        BaseLink.setLinkPermissionsRecursive(link, modules);
      });
    }
    (Links[1] as any).subMenu[2].show = this.GlobalConfigs.use_modifiers

    this.GlobalConfigs.ready = true;

    let lang: string | null = 'es'
    if(localStorage.getItem('lang')) {
      lang = localStorage.getItem('lang')
    } else {
      lang = navigator.language.split('-')[0] || 'es';
    }    
    await this.changeLang(lang);
  }

// Methods
  async changeLang(lang) {
    await loadLanguageAsync(lang);
  }

  private get requestSpinner() {
    return require('@/assets/loading.gif');
  }

  private getLayoutComponent(layout) {
    //Due to the fact that typescript is completely lost.
    //@ts-expect-error
    this.currentLayout = () => import(`@/layouts/${layout}.vue`);
  }

  public initIntercomChat() {
    var APP_ID = "btno6dgc"; 
    //@ts-ignore       
    window.intercomSettings = {
      app_id: APP_ID,
      alignment: 'left'
    };
    (function () {
      var w = window;
      //@ts-ignore       
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        //@ts-ignore       
        ic("update", w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
         //@ts-ignore       
          i.c(arguments);
        };
        //@ts-ignore       
        i.q = [];
        //@ts-ignore
        i.c = function (args) {
          //@ts-ignore
          i.q.push(args);
        };
        //@ts-ignore
        w.Intercom = i;
        var l = function () {
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/" + APP_ID;
          var x = d.getElementsByTagName("script")[0];
          //@ts-ignore
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
          l();
          //@ts-ignore
        } else if (w.attachEvent) {
          //@ts-ignore
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();
  }

  public async mounted() {
    this.initIntercomChat()
  }

}
